export const categories = [
  {
    id: "cat-1",
    name: "角色设定分析",
    slug: "character-analysis",
    description: "深入解读火影忍者经典角色的同人设定、性格解读与二次创作思路",
    icon: "ri-user-star-line",
    articleCount: 8,
  },
  {
    id: "cat-2",
    name: "画风流派鉴赏",
    slug: "art-style",
    description: "盘点不同画师的独特风格，从日系萌系到写实暗黑，领略同人漫画的多元美学",
    icon: "ri-palette-line",
    articleCount: 6,
  },
  {
    id: "cat-3",
    name: "创作技巧分享",
    slug: "creation-tips",
    description: "从分镜设计到上色技法，从剧本构思到排版印刷，同人创作者必备的实用指南",
    icon: "ri-pencil-ruler-2-line",
    articleCount: 7,
  },
  {
    id: "cat-4",
    name: "收藏与鉴赏指南",
    slug: "collection-guide",
    description: "同人本收藏入门到精通，涵盖品相鉴定、保存方法、稀有本识别与市场行情分析",
    icon: "ri-book-2-line",
    articleCount: 5,
  },
  {
    id: "cat-5",
    name: "同人文化起源",
    slug: "culture-origins",
    description: "追踪日本同人文化发展脉络，了解 Comic Market 历史与火影同人圈的演变轨迹",
    icon: "ri-history-line",
    articleCount: 6,
  },
  {
    id: "cat-6",
    name: "周边产品推荐",
    slug: "merchandise",
    description: "精选火影官方周边与高品质同人衍生品推荐，从手办到画集一网打尽",
    icon: "ri-gift-2-line",
    articleCount: 5,
  },
];

export const getCategoryBySlug = (slug: string) =>
  categories.find((c) => c.slug === slug) || null;

export const getCategoryById = (id: string) =>
  categories.find((c) => c.id === id) || null;